import type { ReactNode } from "react";
import { TraceLine } from "@/routes/check/Failures";
import { traceLines } from "@/routes/check/model";
import type { CellRow } from "./model";

/* Ячейка версии (S7, M2): шапка «In [n]  задача n · решение», статус прогона,
   трейсбек; тело — то, что передал экран (код черновика, треды, композер). */

const STATUS: Record<string, { label: string; bg: string; fg: string }> = {
  failed: { label: "упало", bg: "var(--errsoft)", fg: "var(--err)" },
  passed: { label: "прошло", bg: "var(--oksoft)", fg: "var(--ok)" },
  idle: { label: "не запускалось", bg: "transparent", fg: "var(--mut)" },
};

export function cellBorder(row: CellRow): string {
  if (row.threads.length) return "var(--err)";
  if (row.status === "failed") return "var(--bd2)";
  return "var(--bd)";
}

export function CellBox({ row, right, children, id }: { row: CellRow; right?: ReactNode; children?: ReactNode; id?: string }) {
  const st = STATUS[row.status];
  return (
    <section id={id} data-testid="cell" data-task={row.n || undefined} data-cell-id={row.cellId} data-status={row.status} className="overflow-hidden rounded-md bg-bg2 scroll-mt-20" style={{ border: `1px solid ${cellBorder(row)}` }}>
      <div className="flex flex-wrap items-center gap-2.5 bg-card px-3 py-2">
        <span className="font-mono text-[11px] text-mut" title={row.cellId}>
          In [{row.n || "·"}]
        </span>
        <span className="font-mono text-[12px] text-ink">{row.n ? `задача ${row.n} · решение` : `ячейка ${row.cellId}`}</span>
        {row.title && <span className="text-[12px] text-ink2">· {row.title}</span>}
        {st && (
          <span className="rounded-[3px] border px-1.5 py-px font-mono text-[10.5px]" style={{ background: st.bg, color: st.fg, borderColor: st.fg }}>
            {st.label}
          </span>
        )}
        <span className="flex-1" />
        {right}
      </div>
      {row.status === "failed" && (
        <pre data-testid="traceback" className="m-0 overflow-x-auto whitespace-pre-wrap border-t border-bd bg-bg2 px-3.5 py-2.5 font-mono text-[11.5px] leading-[1.55] text-ink">
          {traceLines({ n: row.n, title: row.title, kind: row.kind || "Error", assertLine: row.assertLine, cellId: row.cellId, traceback: row.traceback }).map((l, i) => (
            <TraceLine key={i} line={l} />
          ))}
        </pre>
      )}
      {children}
    </section>
  );
}
